var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('v-select',_vm._g(_vm._b({model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}},'v-select',_vm.bindProps,false),_vm.bindEvents)),_vm._v(" "),_vm._l((_vm.inputVals),function(e){return _c('input',_vm._b({attrs:{"type":"hidden"}},'input',e,false))})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }